import * as React from 'react'
import { makeArr } from '@app/utils/helpers'

// Context
import { SubmissionContext } from '@app/context/SubmissionProvider'

const withContext = (Component: React.SFC<{ data: any }>) => (props: WithContext.IProps) => {
  const { config } = props
  const dataset = makeArr(config.dataset)

  const contexts: any = {
    submission: SubmissionContext,
  }

  const wrap = (i: any, value?: any) => {
    const Wrap: any = contexts[dataset[i]].Consumer
    return (
      <Wrap>
        {(v: any) =>
          dataset[i + 1] ? wrap(i + 1, { ...value, ...v }) : <Component data={{ ...value, ...v }} {...props} />
        }
      </Wrap>
    )
  }

  return wrap(0, {})
}

export default withContext
